import React, {Component} from 'react'
import {Form, Select, Row, Col, Button, Table, message, DatePicker} from 'antd';
import {listFormItemLayout} from '../../utills/common'
import LinkButton from '../../components/link-button'
import {baseUrl, reqBarcodeInfos} from '../../api'
import authorizeBase from "../../components/authorize/authorizeBase";
const AuthButton = authorizeBase(Button)
const AuthLinkButton = authorizeBase(LinkButton)
const {Option} = Select;

class BarcodeList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: []
        };
    }

    handleSubmit = e => {
        e.preventDefault();
        this.getProducts(1);
    };
    getProducts = async (pageNum) => {
        const pageSize = 10;
        const {getFieldsValue} = this.props.form;
        const values = getFieldsValue();
        values.pageNum = pageNum;
        values.pageSize = pageSize;
        values.createDtFrom = this.state.createDtFrom
        values.createDtTo = this.state.createDtTo
        let result = await reqBarcodeInfos(values)
        if (result.code === 200) {
            this.setState({
                pageNum: pageNum,
                total: result.data.total,
                list: result.data.rows
            })
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {
            message.error(result.message)
        }

    };

    onDateChange = (value, dateString,key) => {
        this.setState({
            [key]: dateString
        })
    }
    componentDidMount() {
        this.getProducts(1);
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        const columns = [
            {
                title: '收货人',
                dataIndex: 'receiver',
            },
            {
                title: '收货人电话',
                dataIndex: 'phone',
            },
            {
                title: '收货人地址',
                dataIndex: 'address',
            },
            {
                title: '数量',
                dataIndex: 'nums',
            },
            {
                title: '创建时间',
                dataIndex: 'createDt',
            },
            {
                title: '操作',
                dataIndex: 'opt',
                render: (text, record) => (
                    <span><AuthLinkButton onClick={() => this.props.history.push('/barcodeAdd', {id: record.id})}>编辑</AuthLinkButton>
                        <a href={baseUrl + "/api/v1/p/barcode/export?infoId=" + record.id}>下载  </a>
                        <a href={baseUrl + "/api/v1/p/barcode/download?infoId=" + record.id}>  下载图片</a>
                    </span>
                )
            },
        ];
        return (
            <div>
                <div className='box-shadow margin-bootom'>
                    <br/>
                    <Form {...listFormItemLayout} onSubmit={this.handleSubmit}>
                        <Row>
                            <Col span={8}>
                                <Form.Item label="创建日期">
                                    {getFieldDecorator('createDtFrom')(<DatePicker style={{width:"100%",minWidth:10}}
                                                                                   showTime
                                                                                   format="YYYY-MM-DD HH:mm:ss"
                                                                                   onChange={(value, dateString)=>{this.onDateChange(value,dateString,"createDtFrom")}}
                                    />)}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="至">
                                    {getFieldDecorator('createDtTo')(<DatePicker style={{width:"100%",minWidth:10}}
                                                                                 showTime
                                                                                 format="YYYY-MM-DD HH:mm:ss"
                                                                                 onChange={(value, dateString)=>{this.onDateChange(value,dateString,"createDtTo")}}
                                    />)}
                                </Form.Item>
                            </Col>
                            <Col span={6} style={{float: 'right', marginBottom: '20px'}}>
                                <Button type='primary' htmlType='submit'
                                        style={{float: 'right', marginRight: '13%'}}>查询</Button>
                                <AuthButton type='primary' style={{float: 'right', marginRight: '20px'}} onClick={e=>{
                                    this.props.history.push('/barcodeAdd')
                                }}>新增</AuthButton>
                            </Col>
                        </Row>
                    </Form>
                </div>
                <div className='box-shadow'>
                    <Table columns={columns}  bordered dataSource={this.state.list}
                           rowKey='id'/* scroll={{x: 1300}}*/ size="middle"
                           pagination={{
                               current: this.state.pageNum,
                               total: this.state.total,
                               showQuickJumper: true,
                               onChange: this.getProducts,
                           }}
                    />
                </div>
            </div>
        );
    }
}
const BarcodeListForm = (Form.create()(BarcodeList));
export default BarcodeListForm